export default __webpack_public_path__ + "static/media/yuk_belajar_white.66222767.svg";